module.exports = __webpack_public_path__ + "static/media/jcb.a22cc774.svg";